import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout, ConversationRoutes } from 'entities/ExportRouters'

export const HubspotWorkflowsAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.hubspot_workflows}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: ConversationRoutes.root,
        })
      }}
    />
  )
})
